module.exports = __webpack_public_path__ + "img/ford-plaza-gal-2.4ead90e2.jpg";